<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, defineProps, computed, } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import VerificationCode from '@/components/cloudCounter/VerificationCode.vue';

import { useRouter } from 'vue-router';
const router = useRouter();

const goNextPage = () => {
    router.push({ name: 'cloudCounterFinish' });
};


//驗證碼
const verifyCode = ref('');

//倒數中
const isCounting = ref(false);
const beginCounting = () => {
    isCounting.value = true;
    verifyCode.value = '';
}
const stopCounting = () => {
    isCounting.value = false;
}

</script>

<template>

    <Layout :header="{ text: '受益人變更', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="3"></Process>
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-2">
                行動電話驗證
            </h2>
            <p>已發送動態密碼至你的行動電話 091*****44</p>
        </div>

        <div class="pb-4">

            <VerificationCode :isImmediate="true" buttonText="索取新動態密碼" :buttonDisabled="isCounting"
                :beginCounting="beginCounting" :stopCounting="stopCounting">
                <input type="text" placeholder="請輸入 6 碼動態密碼" maxlength="6" size="6" v-model="verifyCode" />
            </VerificationCode>

        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="isCounting ? (verifyCode === '') : true" @click="goNextPage">確認</button>
        </template>

    </Layout>

</template>

<style scoped></style>
